const KEY_PERSIST_STORE = "fight-booking-app";
const BASE_PATH = process.env.REACT_APP_BASE_PATH;

export { KEY_PERSIST_STORE, BASE_PATH };
